import { createApp, defineAsyncComponent } from 'vue';
import plugin from '@/plugins';
import util from '@/common/util';
// import advRegister from '@/components/sign-log/advertising-register/register.js';
import { isShowCookieAuthority } from './theme/mixin.js';
import { getCookieSetting, COOKIE_LEVEL } from "./cookieStatus.js";
const themeMap = {
    standard: defineAsyncComponent(() =>
        import(
            /* webpackChunkName: "common/cookie-authority/standard" */ './theme/standard.vue'
        )),
    ca: defineAsyncComponent(() => import(
        /* webpackChunkName: "common/cookie-authority/ca" */ './theme/ca.vue'
    ))
};

const getThemeMD = () => {
    const setting = getCookieSetting(util);
    if (setting[COOKIE_LEVEL.ca] === true) {
        return themeMap.ca;
    }
    return themeMap.standard
}

/**
 *  condition : 1.  not logged in  2.  not asked  3.  No AD
 */
export default function() {

    return new Promise((resolve) => {
        if (util.isScreenshot) {
            resolve()
            return
        }
        const isCmsListing = window.location.href.includes('/listing-for-cms');
   
        if (util.inCms || isCmsListing || util.getQueryField('hideCookieBanner') === '1' || util.inIframePreview) {
            resolve()
            return
        }
        const setting = getCookieSetting(util);
        if (!setting[COOKIE_LEVEL.showCookieBanner]) {
            return resolve();
        }
        if (isShowCookieAuthority()) {
            let cookieAuthority = createApp(
                getThemeMD(),
                {
                    onDestroy: () => {
                        if (cookieAuthority) {
                            cookieAuthority.unmount();
                            cookieAuthority = null;
                        }
                        resolve()
                    }
                }
            );
            plugin.baseInstall(cookieAuthority, true);
            cookieAuthority.mountSelf();
        } else {
            resolve()
        }
    })

}
